import React from 'react';
import Wedding from '../Wedding';
type Props = {};

const WeddingContainer = (props: Props) => {
  return <Wedding />;
};

export default WeddingContainer;
